'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _defineProperty = require('@babel/runtime/helpers/defineProperty');
var checkbox = require('./checkbox.js');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_defineProperty);
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty__default["default"](target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
var parts = ['container', 'control', 'label', 'icon'];

// `icons/check.svg`. Not optimal, but it's only ~922 bytes.
// @TODO: Use `import.meta.url` after moving to hausgold/mono to directly reference `check.svg`.
var checkSvg = "PHN2ZyB3aWR0aD0iMjRweCIgaGVpZ2h0PSIyNHB4IiB2aWV3Qm94PSIwIDAgMjQgMjQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICAgICAgPHBhdGgKICAgICAgICAgICAgICAgIGQ9Ik05LjU4MjI5OTk0LDE4LjAxMjQyIEwyMS4xMjQ0NDU2LDQuMzc4MjU0NjIgQzIxLjUxODI2MjgsMy45MTMwNTQ0NyAyMi4yMDE4Nzc5LDMuODcwOTEzNDkgMjIuNjQ1OTM1Myw0LjI4NTM3MDc4IEMyMy4wODE0MTQ1LDQuNjkwNTkwOTUgMjMuMTIwMTk4LDUuMzg0MjM3OTkgMjIuNzM0NDQyNyw1LjgzODk0ODk2IEwxMC41MTM0NDIyLDIwLjI3NTExNjEgQzEwLjMwODUzNzMsMjAuNTE3NTcxNSAxMC4wMTUwNDk4LDIwLjY1MzEyNzYgOS43MDgyNzg1MSwyMC42NTMxMjc2IEM5LjQ2NDA3NDc3LDIwLjY1MzEyNzYgOS4yMjY2MzkzNCwyMC41NjczNzIzIDkuMDMzOTc5NDQsMjAuNDA1NzU2NiBMMS4zOTU2ODQyMSwxMy45ODk1Mzk0IEMwLjk0MDg1NTgzMiwxMy42MDcyNTkgMC44Njc5NTUxMjYsMTIuOTE4MDAzNCAxLjIyOTk4Nzg1LDEyLjQ0MjAwNTYgQzEuNTk4NDM0MDgsMTEuOTU4NDE2MiAyLjI4MTIxMTUsMTEuODc4NDg0NCAyLjc0MzU4MjM3LDEyLjI2ODAwODMgTDkuNTgyMjk5OTQsMTguMDEyNDIgWiIgaWQ9ImNoZWNrIiBmaWxsPSIjZmZmIiBmaWxsLXJ1bGU9Im5vbnplcm8iPjwvcGF0aD4KPC9zdmc+";
function baseStyleControl(props) {
  var _Checkbox$baseStyle = checkbox["default"].baseStyle(props),
    control = _Checkbox$baseStyle.control;
  return _objectSpread(_objectSpread({}, control), {}, {
    borderRadius: 'full',
    _checked: _objectSpread(_objectSpread({}, control._checked), {}, {
      backgroundImage: "url(data:image/svg+xml;base64,".concat(checkSvg, ")"),
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      backgroundSize: '62.5%'
    })
  });
}
var baseStyle = function baseStyle(props) {
  return {
    label: checkbox["default"].baseStyle(props).label,
    control: baseStyleControl(props),
    icon: checkbox["default"].baseStyle(props).icon
  };
};
var sizes = {
  sm: {
    control: {
      width: 3.5,
      height: 3.5
    },
    label: {
      fontSize: 'md'
    },
    icon: {
      fontSize: 'xs'
    }
  },
  md: {
    control: {
      w: 4,
      h: 4
    },
    label: {
      fontSize: 'lg'
    },
    icon: {
      fontSize: 'xs'
    }
  },
  lg: {
    control: {
      w: 5,
      h: 5
    },
    label: {
      fontSize: 'xl'
    },
    icon: {
      fontSize: 'xs'
    }
  }
};
var defaultProps = {
  size: 'md',
  colorScheme: 'blue'
};
var Radio = {
  parts: parts,
  baseStyle: baseStyle,
  sizes: sizes,
  defaultProps: defaultProps
};
exports["default"] = Radio;